import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import LeftSVG from "../assets/page_svg/vector.svg";
import RightSVG from "../assets/page_svg/about-us.svg";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsappButton";
import { Link } from "react-router-dom";
import RondleidingForm from "../components/RondleidingForm";

const About: React.FC = () => {
  const { t } = useLanguage();
    const [openForm, setOpenForm] = React.useState<null | "rondleiding">(null);

  // const stats = [
  //   {
  //     number: "15+",
  //     label: t("about.experience"),
  //     icon: "📅",
  //   },
  //   {
  //     number: "150+",
  //     label: t("about.children"),
  //     icon: "👶",
  //   },
  //   {
  //     number: "25+",
  //     label: t("about.staff"),
  //     icon: "👩‍🏫",
  //   },
  //   {
  //     number: "98%",
  //     label: t("about.satisfaction"),
  //     icon: "⭐",
  //   },
  // ];

  const values = [
    {
      icon: "🛡️",
      title: t("about.valuesList.safety"),
      description: t("about.valuesDescriptions.safety"),
    },
    {
      icon: "🎨",
      title: t("about.valuesList.learning"),
      description: t("about.valuesDescriptions.learning"),
    },
    {
      icon: "❤️",
      title: t("about.valuesList.respect"),
      description: t("about.valuesDescriptions.respect"),
    },
    {
      icon: "🤝",
      title: t("about.valuesList.community"),
      description: t("about.valuesDescriptions.community"),
    },
  ];

  // const team = [
  //   {
  //     name: t("about.teamMembers.sarahJohnson.name"),
  //     role: t("about.teamMembers.sarahJohnson.role"),
  //     experience: t("about.teamMembers.sarahJohnson.experience"),
  //     image: "👩‍💼",
  //     description: t("about.teamMembers.sarahJohnson.description"),
  //   },
  //   {
  //     name: t("about.teamMembers.mariaRodriguez.name"),
  //     role: t("about.teamMembers.mariaRodriguez.role"),
  //     experience: t("about.teamMembers.mariaRodriguez.experience"),
  //     image: "👩‍🏫",
  //     description: t("about.teamMembers.mariaRodriguez.description"),
  //   },
  //   {
  //     name: t("about.teamMembers.davidChen.name"),
  //     role: t("about.teamMembers.davidChen.role"),
  //     experience: t("about.teamMembers.davidChen.experience"),
  //     image: "🏃‍♂️",
  //     description: t("about.teamMembers.davidChen.description"),
  //   },
  //   {
  //     name: t("about.teamMembers.lisaThompson.name"),
  //     role: t("about.teamMembers.lisaThompson.role"),
  //     experience: t("about.teamMembers.lisaThompson.experience"),
  //     image: "🍎",
  //     description: t("about.teamMembers.lisaThompson.description"),
  //   },
  // ];

  const testimonials = [
    {
      name: t("about.parentTestimonials.emmaAndTom.names"),
      child: t("about.parentTestimonials.emmaAndTom.child"),
      text: t("about.parentTestimonials.emmaAndTom.text"),
      rating: 5,
    },
    {
      name: t("about.parentTestimonials.annaAndMark.names"),
      child: t("about.parentTestimonials.annaAndMark.child"),
      text: t("about.parentTestimonials.annaAndMark.text"),
      rating: 5,
    },
    {
      name: t("about.parentTestimonials.lisaAndJames.names"),
      child: t("about.parentTestimonials.lisaAndJames.child"),
      text: t("about.parentTestimonials.lisaAndJames.text"),
      rating: 5,
    },
  ];

  return (
    <div
      className="relative min-h-screen overflow-visible"
      style={{ backgroundColor: "#F9DCAC" }}
    >
      <div className="relative z-10">
        {/* Hero Section */}
        <section className="relative py-20 px-4 sm:px-6 lg:px-8 hero-section-h">
          {/* Decorative SVGs (scaled with container) */}
          <div className="absolute inset-0 pointer-events-none z-0">
            {/* Left SVG */}
            <img
              src={LeftSVG}
              alt="left decoration"
              className="absolute top-0 left-0 max-w-[150px] sm:max-w-[220px] lg:max-w-[280px] w-full opacity-100"
            />
            {/* Right SVG */}
            <img
              src={RightSVG}
              alt="right decoration"
              className="absolute bottom-0 right-0 max-w-[220px] sm:max-w-[220px] md:max-w-[250px] lg:max-w-[350px] w-full opacity-100"
            />
          </div>
          <div className="max-w-6xl mx-auto text-center z-10 relative">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-child font-semibold text-black mb-6">
              {t("about.title")}
            </h1>
            <p className="text-xl md:text-2xl text-black max-w-3xl mx-auto leading-relaxed">
              {t("about.subtitle")}
            </p>
          </div>
        </section>

        {/* Mission & Vision Section */}
        <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Mission */}
              <div className="bg-[#FBEACD] rounded-3xl p-8 min-h-72 shadow-soft hover:shadow-warm transition-all hover:scale-105 duration-300">
                <div className="text-4xl mb-6">🎯</div>
                <h2 className="text-3xl font-child font-semibold text-black mb-6">
                  {t("about.mission")}
                </h2>
                <p className="text-neutral-800 leading-relaxed text-lg">
                  {t("about.missionText")}
                </p>
              </div>

              {/* Vision */}
              <div className="bg-[#FBEACD] rounded-3xl p-8 min-h-72 shadow-soft hover:shadow-warm transition-all hover:scale-105 duration-300">
                <div className="text-4xl mb-6">🔮</div>
                <h2 className="text-3xl font-child font-semibold text-black mb-6">
                  {t("about.vision")}
                </h2>
                <p className="text-neutral-800 leading-relaxed text-lg">
                  {t("about.visionText")}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        {/* <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-child font-semibold text-black mb-6">
                {t("about.ourImpact")}
              </h2>
              <p className="text-xl text-neutral-800 max-w-3xl mx-auto leading-relaxed">
                {t("about.teamText")}
              </p>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft hover:shadow-warm transition-all duration-300 transform hover:scale-105">
                    <div className="text-4xl mb-4">{stat.icon}</div>
                    <div className="text-4xl font-child font-semibold text-[#492A19] mb-2">
                      {stat.number}
                    </div>
                    <div className="text-black font-medium">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Values Section */}
        <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-child font-semibold text-black mb-6">
                {t("about.values")}
              </h2>
              <p className="text-xl text-neutral-800 max-w-3xl mx-auto leading-relaxed">
                {t("about.principlesThatGuide")}
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft hover:shadow-warm transition-all duration-300 transform hover:scale-105 text-center"
                >
                  <div className="text-5xl mb-6">{value.icon}</div>
                  <h3 className="text-xl font-child font-semibold text-black mb-4">
                    {value.title}
                  </h3>
                  <p className="text-neutral-800 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Team Section */}
        {/* <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-child font-semibold text-black mb-6">
                {t("about.team")}
              </h2>
              <p className="text-xl text-neutral-800 max-w-3xl mx-auto leading-relaxed">
                {t("about.meetTeam")}
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {team.map((member, index) => (
                <div
                  key={index}
                  className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft hover:shadow-warm transition-all duration-300 transform hover:scale-105  text-center"
                >
                  <div className="text-6xl mb-6">{member.image}</div>
                  <h3 className="text-xl font-child font-semibold text-black mb-2">
                    {member.name}
                  </h3>
                  <p className="text-[#492A19] font-medium mb-2">
                    {member.role}
                  </p>
                  <p className="text-sm text-neutral-500 mb-4">
                    {member.experience}
                  </p>
                  <p className="text-neutral-800 leading-relaxed text-sm">
                    {member.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Testimonials Section */}
        <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-child font-semibold text-black mb-6">
                {t("about.whatParentsSayTitle")}
              </h2>
              <p className="text-xl text-neutral-800 max-w-3xl mx-auto leading-relaxed">
                {t("about.whatParentsSaySubtitle")}
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft hover:shadow-warm transition-all duration-300 "
                >
                  <div className="flex items-center justify-center mb-6">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span key={i} className="text-2xl text-warm-500">
                        ⭐
                      </span>
                    ))}
                  </div>
                  <p className="text-neutral-700 text-center mb-6 italic leading-relaxed">
                    "{testimonial.text}"
                  </p>
                  <div className="flex items-center justify-center">
                    {/* <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center text-[#492A19] font-semibold text-lg mr-4">
                      {testimonial.name
                        .split(" ")
                        .map((n: string) => n[0])
                        .join("")}
                    </div> */}
                    <div>
                      <p className="font-child font-semibold text-black">
                        {testimonial.name}
                      </p>
                      <p className="text-sm text-neutral-800">
                        {t("cta.parentOf")} {testimonial.child}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-child font-semibold text-black mb-6">
              {t("about.ctaJoinFamily")}
            </h2>
            <p className="text-xl text-neutral-800 mb-8 leading-relaxed">
              {t("about.ctaExperience")}
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <button
                className="inline-flex items-center justify-center px-8 py-3 bg-[#FBEACD] text-[#492A19] font-child font-semibold text-lg rounded-full shadow-warm hover:bg-[#492A19] hover:text-[#F9DCAC] transition-all duration-300 transform hover:scale-105 border-2"
                style={{ borderColor: "#492A19" }}
                onClick={() => setOpenForm("rondleiding")}
              >
                {t("about.scheduleVisit")}
              </button>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-3 bg-[#FBEACD] text-[#492A19] font-child font-semibold text-lg rounded-full border-2 hover:bg-[#492A19] hover:text-[#F9DCAC] transition-all duration-300 transform hover:scale-105"
                style={{ borderColor: "#492A19" }}
              >
                {t("about.contactUs")}
              </Link>
            </div>
          </div>
        </section>
      </div>
      {/* Forms Modals */}
      {openForm === "rondleiding" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4 sm:px-6">
          <div className="bg-[#FBEACD] rounded-2xl p-8 max-w-lg w-full relative">
            <button
              onClick={() => setOpenForm(null)}
              className="absolute top-4 right-4 text-2xl"
            >
              &times;
            </button>
            <RondleidingForm />
          </div>
        </div>
      )}

      {/* WhatsApp Floating Contact Button */}
      <WhatsAppButton />

      <Footer />
    </div>
  );
};

export default About;
